import Button from 'components/Button/index'
import VirtualizedCheckboxGroup from 'components/UIComponents/Filter/index'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CheckIconWhite from 'components/icons/CheckIconWhite'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Dashboard/Partials/UsersFilter/Styles/style'
import { StateCityMessage } from 'modules/Systemconfig/Partials/TableSettings/Style/style'
import React, { useEffect, useState } from 'react'
import { getListOfInstituteLocation } from '../../Onboarding/actions.js'
import StatusFilter from './StatusFilter.js/index.js'
import OnboardingStatusFilter from './StatusFilter.js/onboardingStatus.js'
const { COUNTRY_ID } = process.env

const InstituteFilter = ({
  instituteList,
  currentPage,
  searchValue,
  setSearchValue,
  userRoleValue,
  instituteActiveStatus,
  setInstituteActiveStatus,
  location,
  setLocation,
  filterData,
  setFilterData,
  stateId,
  setStateId,
  stateList,
  setStateList,
  stateNames,
  setStateNames,
  getListOfState,
  cityList,
  setCityList,
  cityName,
  setCityName,
  getListOfCity,
  cityId,
  setPermCityId,
  setInstituteStatus,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [uniqueStateId, setUniqueStateId] = useState('')
  const [degreeSearch, setDegreeSearch] = useState('')
  const [instituteActiveStatusFilter, setInstituteActiveStatusFilter] =
    useState([])
  const [instituteStatusFilter, setInstituteStatusFilter] = useState([])
  const [check, setCheck] = useState(false)

  const fetchInstituteBasedPlaces = async (
    groupBy = 'state',
    search = '',
    stateId = '',
    loading = true
  ) => {
    try {
      setLoading(loading)

      const response = await getListOfInstituteLocation(
        groupBy,
        0,
        search,
        stateId
      )
      if (groupBy === 'state') {
        setStateList(response || [])
      } else {
        setCityList(response || [])
      }
    } catch (err) {
      console.error('Failed to fetch corporate data:', err)
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  }

  useEffect(() => {
    fetchInstituteBasedPlaces('state', '')
    fetchInstituteBasedPlaces('city', '')
  }, [])

  useEffect(() => {
    setPermCityId('')
    setCityName('')
    let list = stateList?.filter(item => stateId?.includes(item.state))
    let stateIdList = list?.map(item => item.stateId)?.join(',')
    setUniqueStateId(stateIdList)
    fetchInstituteBasedPlaces('city', '', stateIdList, false)
  }, [stateId])

  const submitFilter = () => {
    setIsMenuOpen(false)
    setFilterData({
      status: instituteActiveStatusFilter,
      onboardingStatus: instituteStatusFilter,
      stateNames: stateNames || [],
      cityName: cityName,
      stateId: stateId,
      cityId: cityId,
    })

    setInstituteActiveStatus(instituteActiveStatusFilter)
    setInstituteStatus(instituteStatusFilter)
    fetchInstituteBasedPlaces('state', '')
    fetchInstituteBasedPlaces('city', '')
  }
  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    setInstituteActiveStatus(filterData?.status)
    setInstituteActiveStatusFilter(filterData?.status)
    setInstituteStatus(filterData?.onboardingStatus)
    setInstituteStatusFilter(filterData?.onboardingStatus)
  }

  useEffect(() => {
    setCheck(pre => !pre)
    setStateId(filterData?.stateId || [])
    setStateNames(filterData?.stateNames || [])
    setPermCityId(filterData?.cityId || [])
    setCityName(filterData?.cityName || [])
  }, [isMenuOpen])

  const menu = (
    <MenuFlex column className="filter">
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        popupClassName="filter"
        items={[
          {
            label: 'Status',
            key: '1',
            children: (
              <StatusFilter
                instituteActiveStatus={instituteActiveStatusFilter}
                setInstituteActiveStatus={setInstituteActiveStatusFilter}
              />
            ),
          },
          {
            label: 'Onboarding Status',
            key: '2',
            children: (
              <OnboardingStatusFilter
                instituteStatusFilter={instituteStatusFilter}
                setInstituteStatusFilter={setInstituteStatusFilter}
              />
            ),
          },
          {
            label: 'State',
            key: '3',
            children: (
              <VirtualizedCheckboxGroup
                options={stateList}
                value={stateId}
                setValue={setStateId}
                valueParam="state"
                labelParam="state"
                setStateName={setStateNames}
                filterId={true}
                stateName={stateNames}
                loading={loading}
                setLoading={setLoading}
                degreeSearch={degreeSearch}
                setDegreeSearch={setDegreeSearch}
                check={check}
                getStateData={fetchInstituteBasedPlaces}
                labelType={'state'}
              />
            ),
          },
          {
            label: 'City',
            key: '4',
            children: (
              <>
                {stateId?.length ? (
                  <VirtualizedCheckboxGroup
                    options={cityList}
                    value={cityId}
                    setValue={setPermCityId}
                    valueParam="city"
                    labelParam="city"
                    filterId={true}
                    setStateName={setCityName}
                    stateName={cityName}
                    loading={loading}
                    setLoading={setLoading}
                    degreeSearch={degreeSearch}
                    setDegreeSearch={setDegreeSearch}
                    check={check}
                    getStateData={fetchInstituteBasedPlaces}
                    labelType={'city'}
                    uniqueStateId={uniqueStateId}
                  />
                ) : (
                  <StateCityMessage>
                    Kindly select a state before choosing a city.
                  </StateCityMessage>
                )}
              </>
            ),
          },
        ]}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary
          onClick={submitFilter}
          text="Apply Filter"
          icon={<CheckIconWhite />}
        />
      </SubmitFlex>
    </MenuFlex>
  )
  return (
    <TableSearchFilter
      placeholder="Search by Institute"
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={
        10 * (currentPage - 1) +
        ((instituteList?.list?.length || 0) > 0
          ? instituteList.list.length
          : instituteList?.result?.length || 0)
      }
      totalCount={instituteList?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default InstituteFilter
